import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class ToastrWrapperService {

  constructor(private toastrService: ToastrService) { }

  showSuccess(toastMessage: string){
    this.toastrService.success(toastMessage);
  }

  showWarning(toastMessage: string){
    this.toastrService.warning(toastMessage);
  }

  showError(toastMessage: string){
    this.toastrService.error(toastMessage, "", {
      timeOut: 10000
    });
  }

  showInfo(toastMessage: string){
    this.toastrService.info(toastMessage);
  }

  clear(toastMessage: string){
    this.toastrService.clear();
  }
}
